import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from 'react-redux';
import PageBreadcrumb from "../common/PageBreadCrumb";
import PageMeta from "../common/PageMeta";
import ComponentCard from "../common/ComponentCard";
import Label from "../form/Label";
import Input from "../form/input/InputField";
import TextArea from "../form/input/TextArea";
import Select from "../form/Select";
import Button from "../ui/button/Button";
import { CheckLineIcon, CloseLineIcon } from "../../icons";
import Alert from "../../components/ui/alert/Alert";
import { checkAuth, getProfileWithUser, updateCustomer, resetUpdateCustomer, emptyReduxUser } from "../../actions/userAction";
import { ToastContainer, toast } from 'react-toastify';
import { useNavigate, useParams } from 'react-router-dom';
import { logout } from '../../helpers/userAuth';

export default function EditCustomer() {

  const navigate = useNavigate();

  const dispatch = useDispatch();

  const { id } = useParams();
  
  const getProfileWithUserRes = useSelector(state => state.userReducer.getProfileWithUser);
  
  const getProfileWithUserFailed = useSelector(state => state.userReducer.getProfileWithUserFailed);

  const updateCustomerRes = useSelector(state => state.userReducer.updateCustomer);

  const updateCustomerFailed = useSelector(state => state.userReducer.updateCustomerFailed);

  const checkAuthFailed = useSelector(state => state.userReducer.checkAuthFailed);

  const [showLoginLoader, setShowLoginLoader] = useState(false);

  const [showSuccessAlert, setShowSuccessAlert] = useState(false);

  const [firstName, setFirstName] = useState("");
  const [errorFirstName, setErrorFirstName] = useState(false);

  const [lastName, setLastName] = useState("");
  const [errorLastName, setErrorLastName] = useState(false);

  const [email, setEmail] = useState("");
  const [errorEmail, setErrorEmail] = useState(false);
  const [invalidEmail, setInvalidEmail] = useState(false);

  const [phone, setPhone] = useState("");
  const [errorPhone, setErrorPhone] = useState(false);
  const [invalidPhone, setInvalidPhone] = useState(false);

  const [phone2, setPhone2] = useState("");
  const [errorPhone2, setErrorPhone2] = useState(false);
  const [invalidPhone2, setInvalidPhone2] = useState(false);

  const [address, setAddress] = useState("");
  const [errorAddress, setErrorAddress] = useState(false);

  const [address2, setAddress2] = useState("");

  const [city, setCity] = useState("");
  const [errorCity, setErrorCity] = useState(false);

  const [state, setState] = useState("");
  const [errorState, setErrorState] = useState(false);

  const [country, setCountry] = useState("");
  const [errorCountry, setErrorCountry] = useState(false);

  const [pinCode, setPinCode] = useState("");
  const [errorPinCode, setErrorPinCode] = useState(false);

  const [status, setStatus] = useState(false); // false = inactive

  const initialState = {
    // ... other state
    successAlert: false,
  };

  useEffect(() => {
    dispatch(checkAuth());
    dispatch(resetUpdateCustomer());
    dispatch({ type: "RESET_SUCCESS_ALERT" });
    const numericId = Number(id);
    if (!numericId || isNaN(numericId)) {
      navigate("/customer/all");
    } else {
      dispatch(getProfileWithUser(id));
    }
  }, [id]);
 

  useEffect(() => {

    if(checkAuthFailed.statusCode == 401){
      //toast.error(checkAuthFailed.message, {autoClose:2000,onClose: () => {
            dispatch(emptyReduxUser());
            logout();
            navigate("/signin");
      //}});
    }

  }, [checkAuthFailed]);
  
  useEffect(() => {
  
      if(typeof getProfileWithUserRes != "undefined" && getProfileWithUserRes.statusCode == 200){
        console.log("getProfileWithUserRes", getProfileWithUserRes);
  
        let data = getProfileWithUserRes.data;
  
        setFirstName(data.firstName);
        setLastName(data.lastName);
        setEmail(data.user.email);
        setPhone(data.phone);
        setPhone2(data.phone2);
        setAddress(data.address1);
        setAddress2(data.address2)
        setCity(data.city);
        setState(data.state);
        setCountry(data.country);
        setPinCode(data.pinCode);
        setStatus(data.user.status === "active"); // convert to boolean
      }
  
  }, [getProfileWithUserRes]);

  // useEffect(() => {
    
  //   if(typeof updateCustomerRes != "undefined" && updateCustomerRes.statusCode == 200){

  //     console.log(updateCustomerRes.message);

  //     dispatch(resetUpdateCustomer());
      
  //     setShowSuccessAlert(true);
  //     setShowLoginLoader(false);
  //     setTimeout(() => {
  //       setShowSuccessAlert(false);
  //     },5000);
  //   }

  // }, [updateCustomerRes]);
  // useEffect(() => {
  //   if (typeof updateCustomerRes != "undefined") {
  //     setShowLoginLoader(false); // Always stop the loader when we get a response
      
  //     if (updateCustomerRes.status === "error") {
  //       // Handle error response with 200 status
  //       toast.error(updateCustomerRes.message, {position: "bottom-right", autoClose: 4000});
  //     } else if (updateCustomerRes.statusCode == 200) {
  //       // Handle successful response
  //       setShowSuccessAlert(true);
        
  //       setTimeout(() => {
  //         setShowSuccessAlert(false);
  //       }, 5000);
  //     }
  //   }
  // }, [updateCustomerRes]);
  useEffect(() => {
    if (updateCustomerRes) {
      console.log('updatecustomer',updateCustomerRes);
  
      setShowLoginLoader(false);
  
      if (updateCustomerRes.status === "error") {
        toast.error(updateCustomerRes.message || "Update failed", {
          position: "bottom-right",
          autoClose: 4000,
        });
      } else if (updateCustomerRes.statusCode === 200) {
        toast.success(updateCustomerRes.message || "Profile updated successfully", {
                position: "bottom-right",
                autoClose: 4000,
              });
        //toast.success(updateCustomerRes.message || "Profile updated successfully");
        //setShowSuccessAlert(true);
        setShowLoginLoader(false);
        dispatch(resetUpdateCustomer());
        // setTimeout(() => {
        //   setShowSuccessAlert(false);
        // }, 5000);
      }
    }
  }, [updateCustomerRes]);

  useEffect(() => {
    // console.log(getBotOperatorFailed);
    if(updateCustomerFailed && updateCustomerFailed.statusCode == 401){
          //toast.error(createCustomerFailed.message, {autoClose:6000,onClose: () => {
                dispatch(emptyReduxUser());
                logout();
                navigate("/signin");
          //}});
    }
  }, [updateCustomerFailed]);


  const handleChangeNew = (input, event) => {
    
    var value = event.target.value;

    if(input == "firstName"){
      setFirstName(value);
    }

    if(input == "lastName"){
      setLastName(value);
    }

    if(input == "email"){
      setEmail(value);
    }

    if(input == "phone"){
      setPhone(value);
    }

    if(input == "phone2"){
      setPhone2(value);
    }

    if(input == "address"){
      setAddress(value);
    }

    if(input == "address2"){
      setAddress2(value);
    }

    if(input == "city"){
      setCity(value);
    }
    
    if(input == "state"){
      setState(value);
    }
    
    if(input == "country"){
      setCountry(value);
    }
    
    if(input == "pinCode"){
      setPinCode(value);
    }
    if(input == "status"){
      setStatus(value);
    }

  };

  const validateEmail = (email) => {
    return String(email)
      .toLowerCase()
      .match(
        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      );
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    setErrorFirstName(false);
    setErrorLastName(false);
    setErrorEmail(false);
    setInvalidEmail(false);
    setErrorPhone(false);
    setInvalidPhone(false);    
    setErrorPhone2(false);
    setInvalidPhone2(false);
    setErrorAddress(false);
    setErrorCity(false);
    setErrorState(false);
    setErrorCountry(false);
    setErrorPinCode(false);

    var err = [];
    if(firstName.replace(/\s/g, '') == ""){
      err.push("First name");
      setErrorFirstName(true);
    }

    if(lastName.replace(/\s/g, '') == ""){
      err.push("Last name");
      setErrorLastName(true);
    }

    if(email.replace(/\s/g, '') == ""){
      err.push("Email");
      setErrorEmail(true);
    }
    else if(!validateEmail(email)){
      err.push("Email");
      setErrorEmail(true);
      setInvalidEmail(true); 
    }

    if(phone.replace(/\s/g, '') == ""){
      err.push("Phone");
      setErrorPhone(true);
    }
    else if( isNaN(parseInt(phone)) || phone.length !== 10){
      console.log("is", !isNaN(parseInt(phone)));
      console.log("pl", phone.length);
      err.push("Phone");
      setErrorPhone(true);
      setInvalidPhone(true); 
    }

    if(phone2.replace(/\s/g, '') == ""){
      err.push("Secondary phone");
      setErrorPhone2(true);
    }
    else if( isNaN(parseInt(phone2)) || phone2.length !== 10){
      err.push("Secondary phone");
      setErrorPhone2(true);
      setInvalidPhone2(true); 
    }

    if(address.replace(/\s/g, '') == ""){
      err.push("address");
      setErrorAddress(true);
    }

    /*if(address2.replace(/\s/g, '') == ""){
      err.push("address2");
    }*/

    if(city.replace(/\s/g, '') == ""){
      err.push("city");
      setErrorCity(true);
    }

    if(state.replace(/\s/g, '') == ""){
      err.push("state");
      setErrorState(true);
    }

    if(country.replace(/\s/g, '') == ""){
      err.push("country");
      setErrorCountry(true);
    }

    if(pinCode.replace(/\s/g, '') == ""){
      err.push("pincode");
      setErrorPinCode(true);
    }
    console.log("err === ", err);
    if(err.length === 0){
        let data = {
          "firstName" : firstName,
          "lastName" : lastName,
          "email" : email,
          "phone" : phone,
          "phone2": phone2,
          "address1" : address,
          "address2": address2,
          "city" : city,
          "state": state,
          "country" : country,
          "pinCode": pinCode,
          "status" : status ? 'active' : 'inactive',
        };
        setShowLoginLoader(true);
        dispatch(updateCustomer(id, data));
    }
    else{
      toast.error("Invalid data. Please fill all the fields properly.", {position: "bottom-right", autoClose:4000});
    }
  };

  const resetForm = (e) => {
      e.preventDefault();
      setFirstName("");
      setLastName("");
      setEmail("");
      setPhone("");
      setPhone2("");
      setAddress("");
      setAddress2("")
      setCity("");
      setState("");
      setCountry("");
      setPinCode("");

      setErrorFirstName(false);
      setErrorLastName(false);
      setErrorEmail(false);
      setInvalidEmail(false);
      setErrorPhone(false);
      setInvalidPhone(false);    
      setErrorPhone2(false);
      setInvalidPhone2(false);
      setErrorAddress(false);
      setErrorCity(false);
      setErrorState(false);
      setErrorCountry(false);
      setErrorPinCode(false);
  }
  
  return (
    <div>
      <PageMeta
        title="Edit customer | Chit Fund Management System"
        description="Edit customer to Chit Fund Management System"
      />
      <PageBreadcrumb pageTitle="Edit Customer" />
      <div className="grid grid-cols-1 gap-6 xl:grid-cols-1">
        <div className="space-y-12">
          <ComponentCard title="Edit Customer">
          {(
            showSuccessAlert 

            ? 

            <Alert
              variant="success"
              title="Done!"
              message="Edit customer successfully updated."
              showLink={false}
            />

            : 
            
            null
          )}
          <form onSubmit={handleSubmit} className='fadein'>

            <div className="grid grid-cols-1 gap-6 xl:grid-cols-2">

              <div className="space-y-6">
                <div>
                  <Label>First Name <span className="text-red-500">*</span></Label>
                  <Input 
                    type="text" 
                    placeholder="Enter the First Name" 
                    error={errorFirstName} 
                    value={firstName} 
                    onChange={(e) => handleChangeNew("firstName", e)} 
                    hint={errorFirstName ? "This field is required." : ""} 
                  />
                </div>
              </div>
              <div className="space-y-6">
                <div>
                  <Label>Last Name <span className="text-red-500">*</span></Label>
                  <Input 
                    type="text" 
                    placeholder="Enter the Last Name" 
                    error={errorLastName} 
                    value={lastName} 
                    onChange={(e) => handleChangeNew("lastName", e)} 
                    hint={errorLastName ? "This field is required." : ""} 
                  />
                </div>
              </div>
              <div className="space-y-6">
                <div>
                  <Label>Phone number <span className="text-red-500">*</span></Label>
                  <Input 
                    type="text" 
                    placeholder="Enter the Phone number" 
                    error={errorPhone} 
                    value={phone} 
                    onChange={(e) => handleChangeNew("phone", e)} 
                    hint={errorPhone ? (invalidPhone ? "Please Enter 10 digit valid phone no." : "This field is required.") : "" } 
                  />
                </div>
              </div>
              <div className="space-y-6">
                <div>
                  <Label>Secondary Phone number <span className="text-red-500">*</span></Label>
                  <Input 
                    type="text" 
                    placeholder="Enter the Alternative Phone number" 
                    error={errorPhone2} 
                    value={phone2} 
                    onChange={(e) => handleChangeNew("phone2", e)} 
                    hint={errorPhone2 ? (invalidPhone2 ? "Please Enter 10 digit valid phone no." : "This field is required.") : "" } 
                  />
                </div>
              </div>

              <div className="space-y-6">
                <div>
                  <Label>Address <span className="text-red-500">*</span></Label>
                  <Input 
                    type="text" 
                    placeholder="Enter the Address" 
                    error={errorAddress} 
                    value={address} 
                    onChange={(e) => handleChangeNew("address", e)} 
                    hint={errorAddress ? "This field is required." : ""} 
                  />
                </div>
              </div>

              <div className="space-y-6">
                <div>
                  <Label>Address2</Label>
                  <Input 
                    type="text" 
                    placeholder="Enter the Address2" 
                    value={address2} 
                    onChange={(e) => handleChangeNew("address2", e)} 
                  />
                </div>
              </div>

              <div className="space-y-6">
                <div>
                  <Label>City <span className="text-red-500">*</span></Label>
                  <Input 
                    type="text" 
                    placeholder="Enter the city" 
                    error={errorCity} 
                    value={city} 
                    onChange={(e) => handleChangeNew("city", e)} 
                    hint={errorCity ? "This field is required." : ""} 
                  />
                </div>
              </div>

              <div className="space-y-6">
                <div>
                  <Label>State <span className="text-red-500">*</span></Label>
                  <Input 
                    type="text" 
                    placeholder="Enter the State" 
                    error={errorState} 
                    value={state} 
                    onChange={(e) => handleChangeNew("state", e)} 
                    hint={errorState ? "This field is required." : ""} 
                  />
                </div>
              </div>

              <div className="space-y-6">
                <div>
                  <Label>Country <span className="text-red-500">*</span></Label>
                  <Input 
                    type="text" 
                    placeholder="Enter the Country" 
                    error={errorCountry} 
                    value={country} 
                    onChange={(e) => handleChangeNew("country", e)} 
                    hint={errorCountry ? "This field is required." : ""} 
                  />
                </div>
              </div>

              <div className="space-y-6">
                <div>
                  <Label>Pincode <span className="text-red-500">*</span></Label>
                  <Input 
                    type="text" 
                    placeholder="Enter the Pincode" 
                    error={errorPinCode} 
                    value={pinCode} 
                    onChange={(e) => handleChangeNew("pinCode", e)} 
                    hint={errorPinCode ? "This field is required." : ""} 
                  />
                </div>
              </div>

              <div className="space-y-6">
                <div>
                  <Label>Email ID <span className="text-red-500">*</span></Label>
                  <Input 
                    type="email" 
                    placeholder="Enter the Email ID" 
                    error={errorEmail} 
                    value={email} 
                    onChange={(e) => handleChangeNew("email", e)} 
                    hint={errorEmail ? (invalidEmail ? "Please Enter valid Email address." : "This field is required.") : "" } 
                  />
                </div>
              </div>
              <div className="space-y-6">
                <Label>Status</Label>
                <div className="flex items-center space-x-4">
                  <span className="text-sm font-medium text-gray-700">
                    {status ? 'Active' : 'Inactive'}
                  </span>
                  <button
                    type="button"
                    onClick={() => setStatus(!status)}
                    className={`relative inline-flex h-6 w-11 items-center rounded-full transition-colors focus:outline-none ${
                      status ? 'bg-green-500' : 'bg-gray-300'
                    }`}
                  >
                    <span
                      className={`inline-block h-4 w-4 transform rounded-full bg-white transition-transform ${
                        status ? 'translate-x-6' : 'translate-x-1'
                      }`}
                    />
                  </button>
                </div>
              </div>

            </div>
            <div className="space-x-6 mt-6">
                  <Button size="sm" variant="primary" startIcon={( showLoginLoader ? null : <CheckLineIcon />)}>
                    {(
                      showLoginLoader 

                      ? 

                      <span class="animate-spin" ><svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"><circle opacity="0.5" cx="10" cy="10" r="8.75" stroke="white" stroke-width="2.5"></circle><mask id="path-2-inside-1_3755_26472" fill="white"><path d="M18.2372 12.9506C18.8873 13.1835 19.6113 12.846 19.7613 12.1719C20.0138 11.0369 20.0672 9.86319 19.9156 8.70384C19.7099 7.12996 19.1325 5.62766 18.2311 4.32117C17.3297 3.01467 16.1303 1.94151 14.7319 1.19042C13.7019 0.637155 12.5858 0.270357 11.435 0.103491C10.7516 0.00440265 10.179 0.561473 10.1659 1.25187V1.25187C10.1528 1.94226 10.7059 2.50202 11.3845 2.6295C12.1384 2.77112 12.8686 3.02803 13.5487 3.39333C14.5973 3.95661 15.4968 4.76141 16.1728 5.74121C16.8488 6.721 17.2819 7.84764 17.4361 9.02796C17.5362 9.79345 17.5172 10.5673 17.3819 11.3223C17.2602 12.002 17.5871 12.7178 18.2372 12.9506V12.9506Z"></path></mask><path d="M18.2372 12.9506C18.8873 13.1835 19.6113 12.846 19.7613 12.1719C20.0138 11.0369 20.0672 9.86319 19.9156 8.70384C19.7099 7.12996 19.1325 5.62766 18.2311 4.32117C17.3297 3.01467 16.1303 1.94151 14.7319 1.19042C13.7019 0.637155 12.5858 0.270357 11.435 0.103491C10.7516 0.00440265 10.179 0.561473 10.1659 1.25187V1.25187C10.1528 1.94226 10.7059 2.50202 11.3845 2.6295C12.1384 2.77112 12.8686 3.02803 13.5487 3.39333C14.5973 3.95661 15.4968 4.76141 16.1728 5.74121C16.8488 6.721 17.2819 7.84764 17.4361 9.02796C17.5362 9.79345 17.5172 10.5673 17.3819 11.3223C17.2602 12.002 17.5871 12.7178 18.2372 12.9506V12.9506Z" stroke="white" stroke-width="4" mask="url(#path-2-inside-1_3755_26472)"></path></svg></span>

                      : 
                      
                      null
                    )}
                    Submit
                  </Button>
                  {/*<Button size="sm" onClick={resetForm} variant="outline" startIcon={<CloseLineIcon />}>
                    Cancel
                  </Button> */}
              </div>
            </form>
          </ComponentCard>
        </div>
      </div>
      <ToastContainer />
    </div>
  );
}
